import { createFileRoute } from '@tanstack/react-router';
import { ProjectsScreen } from '../../../screens/Projects';

export const Route = createFileRoute('/tasks/projects/')({
  component: ProjectsScreen,
});
